import styled, { keyframes } from 'styled-components';

import { Box } from '@/shared/ui/box';
import { Icon } from '@/shared/ui/icon';

const animation = keyframes`
	from {
		opacity: 0;
		transform: translateY(-5px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
`;

export const Arrow = styled(Icon)<{ open: boolean }>`
	cursor: pointer;
	transform: ${({ open }) => (open ? 'rotate(180deg)' : 'rotate(0deg)')};
	transition: transform 0.3s ease-in-out;
`;

export const FiltersWrapper = styled(Box)`
	animation: ${animation} 0.4s ease-in-out;
`;

export const SelectBox = styled(Box)`
	@media ${({ theme: { media } }) => media.mobile} {
		width: 100%;

		& > * {
			width: 100%;
			max-width: 100%;
		}
	}
`;
